module.exports = __webpack_public_path__ + "static/media/elissa-goad-home-warranty-review_160px.1cfb3454.jpg";